import ReactDOM from "react-dom/client";
import React, { useEffect, useState, useRef } from "react";
import useAuth from "./../../hooks/useAuth";
import { doPost } from "./../../utils/apiCalls";
import { validateEmail } from "../../utils/functions";
import {Link, useNavigate, useLocation} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import DELETE from './../../assets/images/delete.svg'

function Inner() {
  const [selectedfolder, setSelectedFolder] = useState(0);
  
  return (
    <>
      <div className="container-wrappe">
        <div className="main-layout">
            <div className="keywordResearch container">
            <div className="search-container mb-5">
                <section className="header-txt m-0 p-0 text-center">
                <h2 className="text-center">Keyword Research</h2>
                <p>
                    Get accurate and real-time data with suggested titles for your blog
                    post or article.
                </p>
                </section>
                <div className="search-row mt-3 mb-4 row">
                <div className="keywordSearchForm">
                    <form className="">
                    <div className="justify-content-md-center row">
                        <div className="col">
                        <div>
                            <input
                            placeholder="Eg: Green tea"
                            type="text"
                            className="search-input form-control"
                            defaultValue=""
                            />
                        </div>
                        </div>
                        <div className="col">
                        <select className="select-input form-control form-select form-control">
                            <option value="">Select country</option>
                            <option value=" ">Global</option>
                            <option value="us">United States</option>
                            <option value="gb">United Kingdom</option>
                            <option value="in">India</option>
                            <option value="au">Australia</option>
                            <option value="ca">Canada</option>
                            <option value="nz">New Zealand</option>
                            <option value="za">South Africa</option>
                        </select>
                        </div>
                        <div className="col">
                        <button type="submit" disabled="" className="btn btn-primary">
                            Search
                        </button>
                        </div>
                    </div>
                    </form>
                </div>
                </div>
            </div>
            </div>
            <div
            style={{
                position: "fixed",
                zIndex: 9999,
                inset: 16,
                pointerEvents: "none"
            }}
            />
        </div>
        </div>

    </>
);
}

export default Inner;
